import React from "react";
import AboutUs from "../components/AboutUs";
import BreadcrumbTwo from "./../components/BreadcrumbTwo";

const AboutUsPage = () => {
  return (
    <>
      <BreadcrumbTwo title="About Us" />
      <AboutUs />
    </>
  );
};

export default AboutUsPage;